import {
  hasFraudPackage,
  hasPurchaseVerificationPackage,
  hasSegmentationPackage,
  hasUninstallPackage,
  hasControlCenterPackage,
  hasAdRevenuePackage,
  hasMultitouchPackage,
  hasWebAttributionPackage,
  hasSecurityPackage,
} from '@adjust/dashboard-core/lib/utils/account';
import { connectWithStore } from '@common/connectWithStore';
import { getCurrentAccount } from '@redux/ducks/global';
import { AdditionalPackages, Package } from './AdditionalPackages';

const mapStateToProps = state => {
  const account = getCurrentAccount(state);

  const packages: Package[] = [
    {
      name: t('label.fraud-prevention-suite'),
      description: t('fraud-prevention-suite.package.details'),
      isEnabled: hasFraudPackage(account),
    },
    {
      name: t('label.audience-builder'),
      description: t('audience-builder.package.details'),
      isEnabled: hasSegmentationPackage(account),
    },
    {
      name: t('label.uninstall-reinstall-tracking'),
      description: t('uninstall-reinstall.package.details'),
      isEnabled: hasUninstallPackage(account),
    },
    {
      name: t('label.unbotify'),
      description: t('unbotify.package.details'),
      isEnabled: false,
    },
    {
      name: t('label.purchase-verification'),
      description: t('purchase-verification.package.details'),
      isEnabled: hasPurchaseVerificationPackage(account, undefined),
    },
    {
      name: t('label.automate'),
      description: t('automate.package.details'),
      isEnabled: hasControlCenterPackage(account),
    },
    {
      name: t('label.ad_revenue'),
      description: t('ad_revenue.package.details'),
      isEnabled: hasAdRevenuePackage(account),
    },
    {
      name: t('label.multitouch'),
      description: t('multitouch.package.details'),
      isEnabled: hasMultitouchPackage(account),
    },
    {
      name: t('label.web_attribution'),
      description: t('web_attribution.package.details'),
      isEnabled: hasWebAttributionPackage(account),
    },
    {
      name: t('label.security'),
      description: t('security.package.details'),
      isEnabled: hasSecurityPackage(account),
    },
  ];

  return { packages };
};

export const AdditionalPackagesContainer = connectWithStore(mapStateToProps)(AdditionalPackages);
